import useAppSelector from '@sportson/core-web/hooks/useAppSelector';
import CmsModules from '@sportson/core-web/libs/wordpress/content/CmsModules';
import Breadcrumbs from 'components/Breadcrumbs';
import React from 'react';
import { shallowEqual } from 'react-redux';

const Page = () => {
    const heroContent = useAppSelector(({ page }) => page?.data?.heroContent, shallowEqual);
    const pageContent = useAppSelector(({ page }) => page?.data?.pageContent, shallowEqual);
    const { breadcrumbs, title } = useAppSelector(({ page }) => page?.data, shallowEqual);

    const breadcrumbData = breadcrumbs.map((b) => ({ permalink: b.permalink, title: b.title }));
    breadcrumbData.push({ permalink: null, title });

    return (
        <>
            <Breadcrumbs
                gridColumn="standard"
                p={['16px 24px 16px 12px', null, null, null, null, '16px 40px']}
                breadcrumbs={breadcrumbData}
            />
            {heroContent && <CmsModules isHero data={heroContent} />}
            {pageContent && <CmsModules data={pageContent} />}
        </>
    );
};

export default Page;
